// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "74e82652c4c5";
export const BUILD_VERSION_NUMBER = 45;
